"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defaultbinders = _interopRequireDefault(require("../defaultbinders"));

var _lookforbinder = _interopRequireDefault(require("../lookforbinder"));

var _parserbrackets = _interopRequireDefault(require("../parserbrackets"));

var _class = _interopRequireDefault(require("../class"));

var _toseemple = _interopRequireDefault(require("../toseemple"));

var binders = _interopRequireWildcard(require("../binders"));

var universalMethods = _interopRequireWildcard(require("./_universalmethods"));

var _assign = _interopRequireDefault(require("../_helpers/assign"));

var _usedomlibrary = _interopRequireDefault(require("../usedomlibrary"));

var _chain = _interopRequireDefault(require("../chain"));

var _default = (0, _assign["default"])({
  Class: _class["default"],
  defaultBinders: _defaultbinders["default"],
  lookForBinder: _lookforbinder["default"],
  binders: binders,
  parserBrackers: _parserbrackets["default"],
  toSeemple: _toseemple["default"],
  useDOMLibrary: _usedomlibrary["default"],
  chain: _chain["default"]
}, universalMethods);

exports["default"] = _default;
//# sourceMappingURL=_staticmembers.js.map